import { PromotionMailTemplate } from './PromotionMailTemplate.tsx';

export { mailTemplateFormFromApi } from './form.ts';
export { LanguageTabs, useLanguageState } from './LanguageTabs.tsx';

export default PromotionMailTemplate;
